//Polyfill
import "core-js";

//Can't resolve 'regenerator-runtime/runtime'が表示されたとき(async awaitを使う場合など)
//import  regeneratorRuntime  from  "regenerator-runtime" ;
import jQuery from "jquery";

const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)

$(document).ready(function () {
  // .header-btnがクリックされたときの処理
  $(".header-btn").click(function () {
    // .header-btnと.header-spのopenクラスをトグル（追加/削除）
    $(".header-btn, .header-sp").toggleClass("open");
  });

  // .header-sp内のaタグがクリックされたときの処理
  $(".header-sp a").click(function () {
    // .header-btnと.header-spからopenクラスを削除
    $(".header-btn, .header-sp").removeClass("open");
  });
});

// 1. Swiperを制御できるようにモジュールを追加
Swiper.use([Swiper.Controller]);

// 2. スライダー定義
const swiper_first = new Swiper(".swiper_first", {
  loop: true,
  effect: "fade",
  speed: 1000,
  initialSlide: 3,
  fadeEffect: { crossFade: true },
  allowTouchMove: false,
});

const swiper_third = new Swiper(".swiper_third", {
  loop: true,
  effect: "fade",
  speed: 1000,
  initialSlide: 2,
  fadeEffect: { crossFade: true },
  allowTouchMove: false,
});

const swiper_second = new Swiper(".swiper_second", {
  loop: true,
  effect: "fade",
  speed: 1000,
  initialSlide: 0,
  fadeEffect: { crossFade: true },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  controller: {
    control: [swiper_first, swiper_third], // ←連動させたいスライダーを指定
  },
});